import { useCallback, useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import AdminLogin from "./AdminLogin";
import AdminInbox from "./AdminInbox";

export default function AdminPage() {
  const [user, setUser] = useState(null);
  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => api.post("/auth/refresh").then((r) => setUser(r.data)).catch(() => setUser(false)));
  }, []);
  const onLogout = useCallback(() => setUser(false), []);

  if (user === null) return <div className="min-h-screen grid place-items-center bg-[#071510]"><Loader2 className="w-6 h-6 text-[#E5A855] animate-spin" /></div>;
  if (!user) return <AdminLogin onLogin={setUser} />;
  return <AdminInbox user={user} onLogout={onLogout} />;
}
